import React from 'react';

type CreateDepartmentHeader = {
  service?: boolean;
};

const CreateDepartmentHeader = ({ service }: CreateDepartmentHeader) => {
  return (
    <tr style={{ display: 'flex', marginLeft: 140 }}>
      <th
        style={{
          fontSize: 14,
          width: 250,
          background: 'white',
          color: '#000000',
        }}
        className={'common_header_department'}
      >
        {service ? 'Service' : 'Department'}
      </th>
      <th
        style={{
          width: 220,
          background: 'white',
          color: '#000000',
        }}
        className={'common_header_department'}
      >
        {service ? 'Service code' : 'Department Code'}
      </th>
      {service && (
        <th
          style={{
            width: 170,
            background: 'white',
            color: '#000000',
          }}
          className={'common_header_department'}
        >
          Departments *
        </th>
      )}

      <th
        style={{
          width: 170,
          background: 'white',
          color: '#000000',
        }}
        className={'common_header_department'}
      >
        NIF Code
      </th>
      <th
        style={{
          width: 200,
          background: 'white',
          color: '#000000',
        }}
        className={'common_header_department'}
      >
        Business Registration Code
      </th>
      <th
        style={{
          width: 170,
          background: 'white',
          color: '#000000',
        }}
        className={'common_header_department'}
      >
        Organization Code
      </th>
      <th
        style={{
          width: 170,
          background: 'white',
          color: '#000000',
        }}
        className={'common_header_department'}
      >
        Company Code
      </th>
      <th
        style={{
          width: 180,
          background: 'white',
          color: '#000000',
        }}
        className={'common_header_department'}
      >
        Address
      </th>
      <th
        style={{
          width: 300,
          background: 'white',
          color: '#000000',
        }}
        className={'common_header_department'}
      >
        Department Manager <span style={{ color: '#E02C2C', fontSize: 14, fontWeight: 400, marginLeft: 2 }}> {'*'}</span>
      </th>
      <th
        style={{
          width: 180,
          background: 'white',
          color: '#000000',
        }}
        className={'common_header_department'}
      >
        Comments
      </th>
    </tr>
  );
};

export default CreateDepartmentHeader;
